exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h6 {\n  border-radius: 5px;\n  margin: 5px;\n  padding: auto;\n  font-size: large;\n  text-align: center;\n  font-weight: bold; }\n\n.fundoTitulo {\n  border: 1px black solid;\n  border-radius: 5px;\n  margin-bottom: 5px; }\n\n.fundoTitulo2 {\n  border-left: 1px black solid;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  margin-right: 5px; }\n\n.carimbo {\n  border: 1px black solid;\n  border-radius: 5px;\n  height: 160px;\n  margin: 2px;\n  margin: 5px; }\n\ntd {\n  margin: 1px; }\n\n.tituloP {\n  font-size: large;\n  font-weight: bold; }\n\n.tituloC {\n  font-size: large;\n  font-weight: 1300; }\n\n.quadrosTabela {\n  border: 1px black solid;\n  border-radius: 1px;\n  width: 20px;\n  height: 20px;\n  margin: 2px; }\n\n.quadrosTabelaH {\n  margin: 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/solicitacao/relatorio-solicitacao/relatorio-solicitacao.component.scss
// module id = ../../../../../src/app/components/solicitacao/relatorio-solicitacao/relatorio-solicitacao.component.scss
// module chunks = main